import * as React from 'react';
import { Box } from '@mui/material';
import useOverrideInAppLinks from '../../hooks/useOverrideInAppLinks';

import '../../styles/AnnouncementContainer.scss';

export default function AnnouncementContainer ({
  announcements = [],
  view,
}) {
  const [data, setData] = React.useState(null);
  const ref = React.useRef(null);

  useOverrideInAppLinks(ref.current, data);

  React.useEffect(() => {
    const now = new Date();
    const newData = announcements.reduce((acc, curr) => {
      return [...acc, ...curr.answers];
    }, []).filter(announcement => {
      const labels = announcement.labels || {};
      const startDates = labels['start_date'];
      const endDates = labels['end_date'];
      const views = labels['view'];
      if (startDates) {
        for (const date of startDates) {
          if (new Date(date) > now) {
            return false;
          }
        }
      }
      if (endDates) {
        for (const date of endDates) {
          if (new Date(date) < now) {
            return false;
          }
        }
      }
      if (views) {
        if (!views.includes(view)) {
          return false;
        }
      }
      return true;
    });
    newData.forEach(announcement => {
      let text = announcement.body || '';
      const labels = announcement.labels || {};
      text = Object.keys(labels).reduce((acc, label) => {
        return acc.replaceAll(`{{${label}}}`, labels[label]);
      }, text);
      Object.assign(announcement, { text });
    })
    setData(newData);
  }, [announcements, view]);

  if (!data || data?.length <= 0) return null;
  return (
    <Box className='announcement'>
      {data.map((announcement, index) => (
        <Box key={`announcement-${index}`}>
          <div
            ref={ref}
            dangerouslySetInnerHTML={{ __html: announcement.text }}
          />
        </Box>
      ))}
    </Box>
  );
}